import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { ApiService } from '../services/api';
import { Toast } from '../services/toast';

@autoinject
export class MainLayout {
	constructor(public router: Router, private _api:ApiService) {
	}

	eMail: string;

	subscribe() {
		if (!this.eMail) {
			Toast.warning("Please enter your e-mail.");
		}
		else {
			this._api.post("api/subscribers", null, { email: this.eMail }, false)
				.then(() => Toast.info("Thanks for your interest in Fordham Road BID!"));
		}
	}
}
